/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Method_2Inputs */

const en_fw_bm_method_2 = /** @type {(inputs: Fw_Bm_Method_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymous aggregates only. No task text, no repository, no user — a group is hidden until it holds at least 5 tasks.`)
};

const id_fw_bm_method_2 = /** @type {(inputs: Fw_Bm_Method_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya agregat anonim. Tanpa teks task, tanpa repositori, tanpa pengguna — kelompok disembunyikan sampai berisi minimal 5 task.`)
};

/**
* | output |
* | --- |
* | "Anonymous aggregates only. No task text, no repository, no user — a group is hidden until it holds at least 5 tasks." |
*
* @param {Fw_Bm_Method_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_method_2 = /** @type {((inputs?: Fw_Bm_Method_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Method_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_method_2(inputs)
	return en_fw_bm_method_2(inputs)
});